/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {
    Timeline,
    TimelineLite
} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {WinterHoardParsedGameData} from "../server/data/IWinterHoardServerData";

export class SpinStop implements GameRoundPresentation {
    stagger?:number;
    abortStagger?:number;

    constructor(stagger?:number, abortStagger?:number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }


    public getAnimation(data:WinterHoardParsedGameData):Timeline | null {
        return null;
    }

    public abort(isActive:boolean, data:ParsedServerData):Timeline | null {
        return null;
    }

}